import React from 'react'

export const Footer = () => {
  return (
  
  
    <footer class="site-footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <h6>About</h6>
            <p class="text-justify"> 
            Watching movies is a part of almost everyone’s life. They entertain us, teach us lessons, and even help us socialize by giving us topics to talk about with others. As long as movies have been produced, everyone has patronized them.  </p>
          </div>
    
          <div class="col-xs-6 col-md-3">
            <h6>Categories</h6>
            <ul class="footer-links">
              <li>Kids</li>
              <li>Action</li>
              <li>Comidy</li>
              <li>Crime</li>
              <li>Romantic</li>
              <li>Hereur</li>
            </ul>
          </div>
    
          <div class="col-xs-6 col-md-3">
            <h6>Quick Links</h6>
            <ul class="footer-links">
              <li><a href="">About Us</a></li>
              <li><a href="">Contact Us</a></li>
              <li><a href="">Contribute</a></li>
              <li><a href="">Privacy Policy</a></li>
              <li><a href="">Sitemap</a></li>
            </ul>
          </div>
        </div>
        <hr/>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-sm-6 col-xs-12">
            <p class="copyright-text">Copyright &copy; 2022
              <a href="#">WidedBoukouba</a>.
            </p>
          </div>
    
         
        </div>
      </div>
    </footer>

  )
}

export default Footer